import styled from 'styled-components';

const StyledTopTag = styled.div`
  padding: 4px 6px 4px 12px;
  border-radius: 30px;
  font: 14px ${({ theme }) => theme.fontFamily};
  background-color: ${({ theme }) => theme.white};
  border: 1px solid ${({ theme }) => theme.dark70};
  color: ${({ theme }) => theme.bodyMedium};
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 5px;
  svg {
    color: ${({ theme }) => theme.icon};
  }
  &.active {
    background-color: ${({ theme }) => theme.badgeText};
    border: 1px solid ${({ theme }) => theme.badgeText};
    color: ${({ theme }) => theme.white};
    svg {
      color: ${({ theme }) => theme.white};
    }
    &:before {
      border-radius: 50%;
      background-color: rgba(255,255,255,0.6);
      content:'';
      position: absolute;
      top: 50%; left: 50%;
      width:0; height:0;
    }
  }
  &:focus {
    background-color: ${({ theme }) => theme.badgeText};
    color: ${({ theme }) => theme.white};
    svg {
      color: ${({ theme }) => theme.white};
    }
  }
  &:hover {
    background-color: ${({ theme }) => theme.badgeText};
    color: ${({ theme }) => theme.white};
    svg {
      color: ${({ theme }) => theme.white};
    }
  }    
  }
  
`;
export default StyledTopTag;
